import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryAllWebsiteOrderExpress(orderId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-order-express`,
    method: 'get',
    params: {
      orderId
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryWebsiteOrderExpressByOrderId(orderId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-order-express/order/${orderId}`,
    method: 'get',
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryWebsiteOrderExpress(orderExpressId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-order-express/${orderExpressId}`,
    method: 'get',
  });
}

/**
 * 根据 id 查询 订单详细信息；
 * @param  orderExpressId
 * @returns
 */
export function _queryWebsiteOrderExpressTrack(orderExpressId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-order-express/${orderExpressId}/detail`,
    method: 'get',
  });
}
/**
 * 新增
 * @param  orderId
 * @param  expressNo
 * @param  status
 * @param  sender
 * @param  mobile
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addWebsiteOrderExpress(
  {
    orderId,
    expressNo,
    expressCompanyCode,
    status,
    sender,
    phone,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-order-express`,
    method: 'post',
    data: {
      orderId,
      expressNo,
      expressCompanyCode,
      status,
      sender,
      phone,
    },
  });
}

/**
 * 更新
 * @param orderExpressId
 * @param  orderId
 * @param  expressNo
 * @param  status
 * @param  sender
 * @param  mobile
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateWebsiteOrderExpress(orderExpressId, {
  orderId,
  expressNo,
  expressCompanyCode,
  status,
  sender,
  mobile,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-order-express/${orderExpressId}`,
    method: 'patch',
    data: {
      orderId,
      expressNo,
      expressCompanyCode,
      status,
      sender,
      mobile,
    },
  });
}

/**
 * 删除
 * @param orderExpressId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteWebsiteOrderExpress(orderExpressId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-order-express/${orderExpressId}`,
    method: 'delete',
  });
}

export default {};
